import { Base } from '@studiometa/js-toolkit';

/**
 * GorgiasChatButton component
 * Fixes the Gorgias chat button to be a perfect circle with centered icon.
 */
export default class GorgiasChatButton extends Base {
  static config = {
    name: 'GorgiasChatButton',
  };

  /**
   *
   */
  mounted() {
    this.observer = new MutationObserver(() => this.styleChatButton());
    this.observer.observe(this.$el, { childList: true, subtree: true });
    this.styleChatButton();
  }

  /**
   *
   */
  destroyed() {
    this.observer?.disconnect();
  }

  /**
   *
   */
  styleChatButton() {
    const iframe = this.$el.querySelector('iframe#chat-button');
    if (!iframe) return;

    try {
      const doc = iframe.contentDocument || iframe.contentWindow?.document;
      if (!doc?.body?.querySelector('button') || doc.querySelector('#mx-chat-fix')) return;

      const style = doc.createElement('style');
      style.id = 'mx-chat-fix';
      style.textContent = [
        'html, body, #mountHere, .frame-content { width: 100% !important; height: 100% !important; margin: 0 !important; padding: 0 !important; }',
        'h2 { position: absolute !important; width: 1px !important; height: 1px !important; overflow: hidden !important; clip: rect(0, 0, 0, 0) !important; white-space: nowrap !important; border: 0 !important; padding: 0 !important; margin: -1px !important; }',
        '#gorgias-chat-messenger-button { position: relative !important; width: 100% !important; height: 100% !important; border-radius: 50% !important; margin: 0 !important; padding: 0 !important; overflow: hidden !important; }',
        '#gorgias-chat-messenger-button > * { position: absolute !important; top: 50% !important; left: 50% !important; transform: translate(-50%, -50%) !important; }',
        '.messenger-button-iframe-zk0fz7 { max-width: none !important; box-shadow: none !important; }',
      ].join('');
      doc.head.append(style);
    } catch {
      // Cross-origin iframe, skip
    }
  }
}
